import { IMAGES, NAV_LINKS, CONTACT } from "../data/content";

export const Footer = () => (
  <footer data-testid="footer" className="border-t hairline bg-ink py-14">
    <div className="mx-auto max-w-7xl px-5 sm:px-8">
      <div className="flex flex-col gap-10 lg:flex-row lg:items-start lg:justify-between">
        <div className="max-w-sm">
          <div className="flex items-center gap-3">
            <img src={IMAGES.logo} alt="ALBESI AXH METAL" className="h-12 w-12 rounded-full object-cover ring-1 ring-white/15" />
            <span className="font-display text-base font-bold tracking-[0.2em] text-white">
              ALBESI <span className="text-bronze">AXH</span> METAL
            </span>
          </div>
          <p className="mt-4 text-sm leading-relaxed text-white/50">Punime metalike me përvojë, cilësi dhe garanci</p>
          <p className="mt-2 text-sm text-white/40">Çellopek – Tetovë</p>
        </div>

        <nav className="flex flex-col gap-3" data-testid="footer-nav">
          <p className="eyebrow mb-1">Navigim</p>
          {NAV_LINKS.map((l) => (
            <a key={l.href} href={l.href} data-testid={`footer-link-${l.href.slice(1)}`} className="text-sm text-white/55 transition-colors duration-300 hover:text-bronze">
              {l.label}
            </a>
          ))}
        </nav>

        <div className="flex flex-col gap-3" data-testid="footer-contact">
          <p className="eyebrow mb-1">Kontakt</p>
          <a href={CONTACT.phoneHref} className="text-sm text-white/55 transition-colors duration-300 hover:text-bronze">{CONTACT.phoneDisplay}</a>
          <a href={CONTACT.emailHref} className="text-sm text-white/55 transition-colors duration-300 hover:text-bronze">{CONTACT.email}</a>
          <a href={CONTACT.instagram} target="_blank" rel="noopener noreferrer" className="text-sm text-white/55 transition-colors duration-300 hover:text-bronze">Instagram</a>
          <a href={CONTACT.facebook} target="_blank" rel="noopener noreferrer" className="text-sm text-white/55 transition-colors duration-300 hover:text-bronze">Facebook</a>
        </div>
      </div>

      <div className="mt-12 border-t hairline pt-6">
        <p className="text-xs tracking-wide text-white/35" data-testid="footer-copyright">
          © ALBESI AXH METAL. Të gjitha të drejtat e rezervuara.
        </p>
      </div>
    </div>
  </footer>
);
